<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Picker">
	<div class="value-picker-v2">
		<button
			type="button"
			class="value-picker-v2-close"
			(click)="dismiss(null)"
			[attr.aria-label]="'NOTE_EDITOR__CLOSE' | transloco"
		>
			<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">close</span>
		</button>

		<div class="value-picker-v2-header">
			<h2 class="value-picker-v2-title">{{ title | transloco }}</h2>
			<p class="value-picker-v2-description" *ngIf="description">{{ description | transloco }}</p>
		</div>

		<div class="value-picker-v2-content">
			<label class="value-picker-v2-search">
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					search
				</span>
				<input
					type="search"
					[placeholder]="searchPlaceholder || 'SEARCH_FIELD__PLACEHOLDER' | transloco"
					(input)="onNativeSearch($event)"
				/>
			</label>

			<div class="value-picker-v2-list">
				<button
					type="button"
					class="value-picker-v2-item"
					*ngFor="let element of filteredElements; let last = last"
					[class.value-picker-v2-item--last]="last"
					(click)="dismiss(element)"
				>
					<span class="value-picker-v2-item-label">{{ element.name }}</span>
					<span
						class="material-symbols-outlined material-symbols-outlined--size-24 value-picker-v2-check"
						*ngIf="selectedId != null && element.id === selectedId"
						aria-hidden="true"
					>
						check
					</span>
				</button>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #v1Picker>
	<ion-header>
		<ion-toolbar>
			<ion-title>{{ title | transloco }}</ion-title>
			<ion-buttons slot="end">
				<ion-button (click)="dismiss(null)">
					<ion-icon slot="icon-only" name="close-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-toolbar>
		<ion-toolbar *ngIf="description">
			<ion-text>
				<p class="ion-padding-start ion-padding-end">
					{{ description | transloco }}
				</p>
			</ion-text>
			<ion-searchbar
				mode="ios"
				[placeholder]="searchPlaceholder || 'SEARCH_FIELD__PLACEHOLDER' | transloco"
				(ionInput)="onSearchChange($event)"
			></ion-searchbar>
		</ion-toolbar>
	</ion-header>

	<ion-content>
		<ion-list>
			<ion-item *ngFor="let element of filteredElements">
				<div tabindex="0"></div>
				<!-- Weird temp fix for safari 14 -->
				<ion-label (click)="dismiss(element)">{{ element.name }}</ion-label>
			</ion-item>
		</ion-list>
	</ion-content>
</ng-template>
